export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-random/src/defaultSource.js
// module id = ../../../../d3-random/src/defaultSource.js
// module chunks = vendor